import { render, staticRenderFns } from "./NpRecognitionList.vue?vue&type=template&id=d0b9150a&scoped=true"
import script from "./NpRecognitionList.vue?vue&type=script&lang=js"
export * from "./NpRecognitionList.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionList.vue?vue&type=style&index=0&id=d0b9150a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b9150a",
  null
  
)

export default component.exports